import { useCallback } from 'react';
import { useRequestMentions } from 'ui';
// TODO: fix circular dependency
import { useProgramUsersAutocompleteMutation } from '../queries/mutations/useProgramUsersAutocompleteMutation';

export const useProgramMentions = (programId?: string) => {
  const { mutateAsync: requestProgramMentions } = useProgramUsersAutocompleteMutation();

  const onRequestMentions = useCallback(
    async (value: string) =>
      programId ? requestProgramMentions({ limit: 5, programIds: [programId], search: value }) : [],
    [programId, requestProgramMentions],
  );

  return useRequestMentions(onRequestMentions);
};
